import { Controller } from '@hotwired/stimulus';
import { readQrCode, stopScan } from '../js/qr_reader';

// Fiche d'équipement : code d'une étiquette QR saisi ou lu
// par la caméra, vérifié par le serveur (déjà pris, format) ; une lecture
// acceptée remplit le champ (une lecture ratée ne l'efface pas), une saisie
// reste telle quelle (le serveur juge à l'enregistrement). Seules la dernière lecture lancée et sa vérification
// comptent ; la caméra est arrêtée en quittant la page.
export default class extends Controller {
    static targets = ['field', 'message', 'scan', 'video'];
    static values = { model: String, id: String, url: String };

    disconnect() {
        this.stop();
        this.checking = null;
    }

    async scan() {
        this.stop();
        this.checking = null;
        this.scanTarget.hidden = false;
        this.say('', true);
        const scan = { isCurrent: () => this.current === scan };
        this.current = scan;
        let text;
        try {
            text = await readQrCode(this.videoTarget, scan);
        } catch (error) {
            if (this.current === scan) this.say('Caméra indisponible.', false);
            return;
        }
        if (this.current !== scan) return;
        this.stop();
        await this.check(text);
    }

    async check(text, { fill = true } = {}) {
        const checking = {};
        this.checking = checking;
        const query = new URLSearchParams({ qr_code: text, class_name: this.modelValue, id: this.idValue });
        let response;
        try {
            response = await fetch(`${this.urlValue}?${query}`, { headers: { Accept: 'application/json' } });
        } catch (error) {
            response = null;
        }
        if (this.checking !== checking) return;
        if (!response?.ok) {
            this.say('Vérification impossible.', false);
            return;
        }
        const { valid, message } = await response.json();
        if (this.checking !== checking) return;
        this.scanTarget.hidden = true;
        this.say(message, valid !== false);
        if (valid !== false && fill) this.fieldTarget.value = text;
    }

    typed() {
        const text = this.fieldTarget.value.trim();
        if (text) this.check(text, { fill: false });
    }

    say(text, ok) {
        this.messageTarget.textContent = text;
        this.messageTarget.classList.toggle('text-ok', ok);
        this.messageTarget.classList.toggle('text-ko', !ok);
    }

    stop() {
        stopScan(this.current, this.videoTarget);
        this.current = null;
    }
}
